import { useState } from 'react';

interface QuestionInfoProps {
  info: string;
  variant?: 'dark' | 'light';
}

export default function QuestionInfo({ info, variant = 'dark' }: QuestionInfoProps) {
  const [isOpen, setIsOpen] = useState(false);

  const buttonClass = variant === 'light'
    ? 'inline-flex items-center gap-1 text-xs text-slate-400 hover:text-slate-700 transition-colors'
    : 'inline-flex items-center gap-1 text-xs text-slate-400 hover:text-white transition-colors';

  const popoverClass = variant === 'light'
    ? 'mt-2 max-w-xs mx-auto text-sm text-slate-500 bg-slate-100 rounded-lg px-4 py-2.5 text-left'
    : 'mt-2 max-w-xs mx-auto text-sm text-slate-400 bg-white/5 rounded-lg px-4 py-2.5 text-left';

  return (
    <div className="text-center">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={buttonClass}
        aria-expanded={isOpen}
        aria-label="More info"
      >
        <span className="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full border border-current text-[8px] font-bold leading-none pb-px">?</span>
        {isOpen ? 'Hide info' : 'What is this?'}
      </button>
      {isOpen && (
        <p className={popoverClass}>
          {info}
        </p>
      )}
    </div>
  );
}
